<script>
    export default {
        props: [
            'route',
            'locale',
            'consultantUsername',
            'mainYearStart',
            'mainWeekStart',
            'mainYearEnd',
            'mainWeekEnd',
            'compareYearStart',
            'compareWeekStart',
            'compareYearEnd',
            'compareWeekEnd',
            'cacheKey',
            'stat',
            'initConsultantLevel'
        ],
        data() {
            return {
                result: {
                    mainTotal: 0,
                    percentage: 0,
                },
                formatterInteger: null,
                formatter: null
            }
        },
        created() {
            this.formatterInteger = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
            this.formatter = new Intl.NumberFormat(this.locale, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            });
        },
        mounted() {
            this.params = {
                consultantUsername: this.consultantUsername,
                cacheKey: this.cacheKey,
                mainYearStart: this.mainYearStart,
                mainWeekStart: this.mainWeekStart,
                mainYearEnd: this.mainYearEnd,
                mainWeekEnd: this.mainWeekEnd,
                compareYearStart: this.compareYearStart,
                compareWeekStart: this.compareWeekStart,
                compareYearEnd: this.compareYearEnd,
                compareWeekEnd: this.compareWeekEnd,
                stat: this.stat,
                consultantLevel: this.initConsultantLevel,
            };

            this.getData();

            Event.$on('downlineOrdersChanged', (username, userId) => {
                this.params.cacheKey = userId == null ? this.cacheKey : 'i_u_c_f_d_w_' + userId;
                this.params.consultantUsername = username == null ? this.consultantUsername : username;

                this.getData();
            })
        },
        methods: {
            getData() {
                let params = this.params;
                $('.widget--statistic-box--count-introduced-users .div-preloader').fadeIn();
                axios.get(this.route, {
                    params
                })
                    .then((res) => {
                        this.result = res.data.data;
                        $('.widget--statistic-box--count-introduced-users .div-preloader').fadeOut();
                    })
                    .catch((err) => {

                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/app/components/widgets/statistics/boxes/countIntroducedUsers.vue